import { Component, Input, HostListener, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Picture } from '../../models/picture.model';

@Component({
  selector: 'app-gallery',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './gallery.html',
  styleUrl: './gallery.scss',
})
export class Gallery {
  @Input() pictures: Picture[] = [];
  @Input() loading = false;

  // Desktop: 4 visible, mobile: 3 visible
  get displayPictures(): Picture[] {
    return this.pictures.slice(0, 4);
  }

  // Mobile: overlay on 3rd item when total > 3. Shows how many remain.
  get mobileMoreCount(): number {
    return this.pictures.length - 2;
  }

  // Desktop: overlay on 4th item when total > 4. Shows how many remain.
  get desktopMoreCount(): number {
    return this.pictures.length - 3;
  }

  lightboxOpen = false;
  lightboxIndex = 0;

  get lightboxPicture(): Picture | null {
    return this.pictures[this.lightboxIndex] ?? null;
  }

  constructor(private cdr: ChangeDetectorRef) {}

  openLightbox(index: number) {
    this.lightboxIndex = index;
    this.lightboxOpen = true;
    document.body.style.overflow = 'hidden';
  }

  closeLightbox() {
    this.lightboxOpen = false;
    document.body.style.overflow = '';
  }

  prev() {
    this.lightboxIndex = (this.lightboxIndex - 1 + this.pictures.length) % this.pictures.length;
  }

  next() {
    this.lightboxIndex = (this.lightboxIndex + 1) % this.pictures.length;
  }

  goTo(index: number) {
    this.lightboxIndex = index;
  }

  @HostListener('document:keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    if (!this.lightboxOpen) return;
    if (event.key === 'Escape') this.closeLightbox();
    if (event.key === 'ArrowLeft') this.prev();
    if (event.key === 'ArrowRight') this.next();
  }
}
